import React from 'react'
import List from '@mui/material/List'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useTranslation } from 'react-i18next'

export interface ISelection {
  id: number
  name: string
  defaultSelected: boolean
  disabled?: boolean
}

interface IPopupSelectProps {
  selected: number[]
  selections: ISelection[]
  onChange: (ids: number[]) => void
}

const PopupSelect: React.FC<IPopupSelectProps> = ({
  selected,
  selections,
  onChange,
}) => {
  const { t } = useTranslation()
  const sortedSelection = [...selections].sort((a, b) =>
    a.name < b.name ? -1 : 1,
  )

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Add
    if (event.target.checked) {
      onChange([...selected, Number(event.target.name)])
    } else {
      // Remove
      const foundId = selected.find((sel) => sel === Number(event.target.name))
      if (foundId !== undefined) {
        const newSelected = selected.filter((id) => id !== foundId)
        onChange(newSelected)
      }
    }
  }

  const addRemoveAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      onChange(sortedSelection.map((sel) => sel.id))
    } else {
      // Remove
      onChange([])
    }
  }

  return (
    <List
      sx={{
        width: '100%',
        maxWidth: 360,
        bgcolor: 'background.paper',
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
      }}
    >
      <FormGroup>
        <FormControlLabel
          label={<i>{t('popups.selectAll')}</i>}
          control={
            <Checkbox
              checked={selected.length === selections.length}
              onChange={addRemoveAll}
            />
          }
        />
      </FormGroup>
      {sortedSelection.map((selection) => (
        <FormGroup key={selection.id}>
          <FormControlLabel
            label={selection.name}
            control={
              <Checkbox
                checked={selected.includes(selection.id)}
                name={selection.id.toString()}
                onChange={handleChange}
                disabled={selection.disabled}
              />
            }
          />
        </FormGroup>
      ))}
    </List>
  )
}

export default PopupSelect
